import AccountDetails from 'features/accounts/AccountDetails/AccountDetails';
import React from 'react';

export default function Page() {
  return <AccountDetails />;
}
